import React, { Component } from 'react';
import { Route } from 'react-router';
import { Home } from './components/Home';
import { BrowserRouter, Switch, Link } from 'react-router-dom';
import { Admin } from './components/Admin';
import { AuthenticationContext, adalFetch, withAdalLogin } from 'react-adal';
//import { authContext, withAdalLoginApi } from './adalConfig';
import { adalConfigOptions } from './adalConfig';
//const MyProtectedPage = adalConfigOptions.withAdalLoginApi(Admin, () => Admin, (error) => null);
var MyProtectedPage;

export default class App extends Component {
    displayName = App.name;   
    constructor(props) {
        super(props);
        this.state = {
            isAdalLoaded: false           
        }
        const self = this;        
        adalConfigOptions.then(
            configValues => {
                MyProtectedPage = configValues.withAdalLoginApi(Admin, () => Admin, (error) => null);
                self.setState({ isAdalLoaded: true });
            }
        );    
    }
    render() {
        return this.state.isAdalLoaded == true ?
            <div>
                <Route exact path='/' component={Home} />

                <Route path="/admin" render={
                    () => <MyProtectedPage />} />
            </div> : <div className="CA-container"><p><em>Loading...</em></p></div>

    }
}



// WEBPACK FOOTER //
// ./src/App.js